var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{class:{
    'mobile-item__field': _vm.screenWidth <= 768
  },attrs:{"lg":_vm.lg}},[(_vm.screenWidth <= 768)?_c('p',{staticClass:"mobile-item__field-left"},[_vm._t("mobile")],2):_vm._e(),_c('span',{class:{
      'w-100': _vm.screenWidth > 768,
      'mobile-item__field-right': _vm.screenWidth <= 768
    }},[(!_vm.downloading)?_vm._t("content"):_c('b-skeleton',{staticClass:"mb-0",attrs:{"type":"text","width":"100","height":"26px"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }